import { CheckBoxIcon, HelpIcon } from 'assets/icons';
import { Button, ButtonSize, ButtonStyle } from 'common/button';
import { Breakpoints } from 'common/enums';
import { getQueryParam } from 'helpers/utils';
import { useMediaQuery } from 'hooks/use-media-query';
import { VaultsController } from 'networking/controllers/vaults-controller';
import { VaultCard } from 'pages/sign-up-onboarding/components/vault-card/vault-card';
import { useEffect, useRef, useState } from 'react';
import { goToPage, RouteName } from 'routes';
import { SecondSeccionVaultInfo } from './components/second-section-vault-info/second-section-vault-info';
import styles from './onboarding-vault-info.module.scss';

const OnboardingVaultInfo: React.FC = () => {
  const isMobile = useMediaQuery(`(max-width: ${Breakpoints.sm}px)`);
  const selectedOption = getQueryParam('selectedOption') ?? '';
  const vaultId = getQueryParam('vaultId') ?? '';
  const [vaultTitle, setVaultTitle] = useState<string>('');
  const [vaultIcon, setVaultIcon] = useState<string | undefined>('');

  const secondSectionRef = useRef<HTMLDivElement | null>(null);

  const handleScroll = () => {
    if (secondSectionRef.current) {
      const targetElement = secondSectionRef.current;
      const targetPosition =
        targetElement.getBoundingClientRect().top + window.pageYOffset - 100;
      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth',
      });
    }
  };

  const fetchVault = async () => {
    const response = await VaultsController.getVault(Number(vaultId));
    setVaultTitle(response.title);
    setVaultIcon(response.coverUrl);
  };

  useEffect(() => {
    fetchVault();
  }, []);

  const handleStartBuilding = () => {
    goToPage(RouteName.OnboardingSelectCategories, {}, { vaultId });
  };

  const showContentListAboutMe = () => (
    <div className={styles.contentCheckList}>
      <div className={styles.contentRowIcons}>
        <CheckBoxIcon />
        <span className="text__body__regular__large__gray700">
          Upload your own documents & media
        </span>
      </div>
      <div className={styles.contentRowIcons}>
        <CheckBoxIcon />
        <span className="text__body__regular__large__gray700">
          Invite friends & family to make their additions
        </span>
      </div>
      <div className={styles.contentRowIcons}>
        <CheckBoxIcon />
        <span className="text__body__regular__large__gray700">
          Follow guides to record responses to beautiful topics
        </span>
      </div>
    </div>
  );

  const showContentListAboutSomeoneElse = () => (
    <div className={styles.contentCheckList}>
      <div className={styles.contentRowIcons}>
        <CheckBoxIcon />
        <span className="text__body__regular__large__gray700">
          Upload your own documents & media
        </span>
      </div>
      <div className={styles.contentRowIcons}>
        <CheckBoxIcon />
        <span className="text__body__regular__large__gray700">
          Follow guides to record responses to beautiful topics
        </span>
      </div>
      <div className={styles.contentRowIcons}>
        <CheckBoxIcon />
        <span className="text__body__regular__large__gray700">
          Invite friends & family to make their additions
        </span>
      </div>
    </div>
  );

  const showContentAboutUser = () => (
    <div className={styles.content}>
      {selectedOption === 'aboutMe' ? (
        <span className="text__heading4__gray800">
          This <strong>Vault</strong> is the place to capture your albums
          forever.
        </span>
      ) : (
        <span className="text__heading4__gray800">
          This <strong>&ldquo;Vault&ldquo;</strong> is the place to capture{' '}
          {vaultTitle} legacy forever.
        </span>
      )}
      {selectedOption ? (
        <span className="text__body__regular__large__gray700">
          Vaults store & create legacy for future generations:
        </span>
      ) : (
        <span className="text__body__regular__large__gray700">
          Vaults are a place to store & create legacy.
        </span>
      )}
      {selectedOption === 'aboutMe'
        ? showContentListAboutMe()
        : showContentListAboutSomeoneElse()}
      <div className={styles.buttonContent}>
        <Button onClick={handleStartBuilding} buttonSize={ButtonSize.Medium}>
          Start Building
        </Button>
        <Button
          buttonStyle={ButtonStyle.PrimaryGhost}
          className={styles.linkButton}
          onClick={handleScroll}
        >
          Learn more about Vaults
          <HelpIcon className={styles.helpIcon} />
        </Button>
      </div>
    </div>
  );

  return (
    <div className={styles.contentSections}>
      <div className={styles.containerVault}>
        {!isMobile && (
          <VaultCard
            image={vaultIcon}
            name={vaultTitle}
            subtitle="A life story"
          />
        )}
        {showContentAboutUser()}
      </div>
      <div ref={secondSectionRef} className={styles.secondSection}>
        <SecondSeccionVaultInfo />
      </div>
      <Button onClick={handleStartBuilding} buttonSize={ButtonSize.Medium}>
        Start Building
      </Button>
    </div>
  );
};

export { OnboardingVaultInfo };
